module.exports = __webpack_public_path__ + "img/dne-pay.7239bda7.jpg";